export const CUSTOM_DAY_NAMES = ["T2", "T3", "T4", "T5", "T6", "T7", "CN"];

export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";

export const LOCALE = "vi";

export const LANG_CUSTOM = {
  formatLocale: {
    monthsShort: [
      "Thg 1",
      "Thg 2",
      "Thg 3",
      "Thg 4",
      "Thg 5",
      "Thg 6",
      "Thg 7",
      "Thg 8",
      "Thg 9",
      "Thg 10",

      "Thg 11",
      "Thg 12",
    ],

    weekdaysShort: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
    weekdaysMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  },
  weekdays: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  months: [
    "Tháng 1",
    "Tháng 2",
    "Tháng 3",
    "Tháng 4",
    "Tháng 5",
    "Tháng 6",
    "Tháng 7",
    "Tháng 8",
    "Tháng 9",
    "Tháng 10",
    "Tháng 11",
    "Tháng 12",
  ],
  pickers: ["năm trước", "tháng trước", "tuần trước", "ngày trước"],
  placeholder: {
    date: "Chọn ngày",
    dateRange: "Chọn khoảng ngày",
  },
};

